/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrganizationType,
    OrganizationTypeFromJSON,
    OrganizationTypeFromJSONTyped,
    OrganizationTypeToJSON,
} from './OrganizationType';
import {
    WorkspaceType,
    WorkspaceTypeFromJSON,
    WorkspaceTypeFromJSONTyped,
    WorkspaceTypeToJSON,
} from './WorkspaceType';

/**
 * 
 * @export
 * @interface WorkspaceMemberCampaignInvitationResponse
 */
export interface WorkspaceMemberCampaignInvitationResponse {
    /**
     * The campaign's internal ID (unique)
     * @type {string}
     * @memberof WorkspaceMemberCampaignInvitationResponse
     */
    campaignId: string;
    /**
     * Public message for the campaign
     * @type {string}
     * @memberof WorkspaceMemberCampaignInvitationResponse
     */
    campaignMessage?: string;
    /**
     * The name of the organization.
     * @type {string}
     * @memberof WorkspaceMemberCampaignInvitationResponse
     */
    organizationName: string;
    /**
     * The URL for an image representing the organization
     * @type {string}
     * @memberof WorkspaceMemberCampaignInvitationResponse
     */
    organizationImage?: string;
    /**
     * 
     * @type {OrganizationType}
     * @memberof WorkspaceMemberCampaignInvitationResponse
     */
    organizationType: OrganizationType;
    /**
     * The name of the workspace.
     * @type {string}
     * @memberof WorkspaceMemberCampaignInvitationResponse
     */
    workspaceName: string;
    /**
     * 
     * @type {WorkspaceType}
     * @memberof WorkspaceMemberCampaignInvitationResponse
     */
    workspaceType: WorkspaceType;
}

export function WorkspaceMemberCampaignInvitationResponseFromJSON(json: any): WorkspaceMemberCampaignInvitationResponse {
    return WorkspaceMemberCampaignInvitationResponseFromJSONTyped(json, false);
}

export function WorkspaceMemberCampaignInvitationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMemberCampaignInvitationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'campaignId': json['campaignId'],
        'campaignMessage': !exists(json, 'campaignMessage') ? undefined : json['campaignMessage'],
        'organizationName': json['organizationName'],
        'organizationImage': !exists(json, 'organizationImage') ? undefined : json['organizationImage'],
        'organizationType': OrganizationTypeFromJSON(json['organizationType']),
        'workspaceName': json['workspaceName'],
        'workspaceType': WorkspaceTypeFromJSON(json['workspaceType']),
    };
}

export function WorkspaceMemberCampaignInvitationResponseToJSON(value?: WorkspaceMemberCampaignInvitationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'campaignId': value.campaignId,
        'campaignMessage': value.campaignMessage,
        'organizationName': value.organizationName,
        'organizationImage': value.organizationImage,
        'organizationType': OrganizationTypeToJSON(value.organizationType),
        'workspaceName': value.workspaceName,
        'workspaceType': WorkspaceTypeToJSON(value.workspaceType),
    };
}

